import * as Rx from "rxjs"
import { retry } from "rxjs/operators"
import { request } from "../utils/http"
import { DepartmentDTO } from "../components/screens/employees/positions/types"

export const getDepartmentApi = (headers: Record<string, any>): Rx.Observable<DepartmentDTO[]> =>
    Rx.defer(() =>
        request({
            method: "GET",
            path: "/department",
            headers: headers,
        })
    ).pipe(retry(2))
